<script setup>
import { computed, defineProps } from 'vue';

const props = defineProps({
    // トータルページ数
    totalPage: {
        type: Number,
        default: 1
    },
    // 1ページの記事数
    perPage: {
        type: Number,
        default: 12
    },
    // 現在のページ
    currentPage: {
        type: Number,
        default: 1
    },
    // 現在のカテゴリ
    currentCat: {
        type: String,
        default: ''
    },
});

// HTMLレンダリング用のページリストを作成
const pageList = computed(() => {
    const range = 2; //現在のページの両隣にいくつ数字を配置するか(最初/最後のページを除く)
    const current = props.currentPage; //現在のページ
    const last = props.totalPage; //最後のページ

    if (props.totalPage <= 1) return; //トータルページ数が1以下であれば終了

    const r = [current];

    // 現在のページより前
    if (current - 1 >= 1) {
        for (let i = 1; i <= range; i++) {
            if (current - i > 1) r.unshift(current - i); //前のページが2以上であれば追加
        }

        // 前のページ以前を追加
        if (r[0]-1 >= 2) r.unshift('dots'); //2つ前のページが2以上だったら省略記号を追加
        r.unshift(1); //最初のページを追加
    }

    // 現在のページより後
    if (current + 1 <= last) {
        for (let i = 1; i <= range; i++) {
            if (current + i < last) r.push(current + i); //次のページが全体数を下回っていれば追加
        }

        // 次のページ以降を追加
        if (r[r.length-1]+1 < last) r.push('dots'); //2つ後のページが全体数を下回っていたら省略記号を追加
        r.push(last); //最後のページを追加
    }

    return r;
});

// ページのリンクを返す
const pageLink = (num) => {
    let r = '/news/';
    let delimiter = '?';

    // カテゴリ
    if (props.currentCat) {
        r = `${r + delimiter}category=${props.currentCat}`;
        delimiter = '&';
    }
    //2ページ目以降
    if (num > 1) r = `${r + delimiter}page=${num}`;

    return r;
}
</script>

<template>
<!-- pagination -->
<div class="pagination" v-if="totalPage > 1 && pageList">
    <a :href="pageLink(currentPage-1)" class="pagination__arrow" v-if="currentPage !== 1">
        <div class="arrow is-b is-back"></div>
    </a>
    <ul class="pagination__numbers">
        <template v-for="val in pageList" :key="val">
            <li v-if="val !== 'dots'" class="pagination__item" :class="{'is-current': val === currentPage}">
                <a :href="pageLink(val)">{{ val }}</a>
            </li>
            <li v-else class="pagination__item is-dots">
                <a>...</a>
            </li>
        </template>
    </ul>
    <a :href="pageLink(currentPage+1)" class="pagination__arrow" v-if="currentPage !== totalPage">
        <div class="arrow is-b"></div>
    </a>
</div><!-- ./pagination -->
</template>